import * as actionTypes from "./actionTypes";
import axios from "axios";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";
import { fetchUserInfoFailed } from "./fetchUserInfo";

export const fetchAccessTokenStarted = () => {
  return {
    type: actionTypes.FETCH_ACCESS_TOKEN_STARTED,
  };
};
export const fetchAccessTokenFailed = (errorMessage) => {
  return {
    type: actionTypes.FETCH_ACCESS_TOKEN_FAILED,
    errorMessage,
  };
};
export const fetchAccessTokenSuccess = (token) => {
  return {
    type: actionTypes.FETCH_ACCESS_TOKEN_SUCCESS,
    token,
  };
};

export const fetchAccessToken = (email: string, password: string) => {
  return (dispatch) => {
    dispatch(fetchAccessTokenStarted());
    axios
      .post(
        `${process.env.REACT_APP_LOGIN_URL}username=${email}&password=${password}${process.env.REACT_APP_LOGIN_URL_PARAMS}`
        // `https://ampsispace.b2clogin.com/ampsispace.onmicrosoft.com/oauth2/v2.0/token?username=june3@mailinator.com&password=iSpace@123&grant_type=password&scope=openid+7cc4cd5d-e1ac-4f39-b233-8c2626f366f0+offline_access&client_id=7cc4cd5d-e1ac-4f39-b233-8c2626f366f0&response_type=token+id_token&p=B2C_1A_Mobile_ROPC_Dev`
      )
      .then((response) => {
        console.log(response.data);
        dispatch(fetchAccessTokenSuccess(response.data.access_token));
      })
      .catch((error) => {
        dispatch(fetchAccessTokenFailed(error.response.data.error_description.split("\n")[0]));
      });
  };
};
